<template>
  <div>
    <div>
      <!-- <div class="float-right"> -->
        <!-- <b-button variant="primary" size="sm" class="mt-2 mr-2 float-right">人工审核</b-button> -->
      <!-- </div> -->
    <b-tabs>
        <b-tab v-for="file in files" :key="file.id" :title="file.originalName" lazy title-item-class="text-primary">
          <template #title>
            <b-icon icon="check-circle" variant="success" v-if="file.checked && !file.removeable" class="mr-1"></b-icon>
            <b-icon icon="x-circle" variant="danger" v-else-if="!file.checked && !file.removeable" class="mr-1"></b-icon>
            <b-icon icon="file-earmark-text" variant="secondary" v-else-if="file.removeable" class="mr-1"></b-icon>
            {{file.originalName}}<b-btn-close class="pl-3 mt-2 pt-1" @click="remove(file.id, file.originalName)" v-show="file.removeable"></b-btn-close>
          </template>

          <iframe :src="getViewerUrl(file)" frameborder="0" width="100%" :height="tableMaxHeight"></iframe>
        </b-tab>

        <template #tabs-end>
          <b-nav-item role="presentation" href="#" class="text-primary">
            <b-dropdown id="dropdown-1" variant="link" toggle-class="text-decoration-none" size="sm" no-caret>
              <template #button-content>
                <i class="fa fa-plus" aria-hidden="true" ></i>
              </template>
              <b-dropdown-item @click="showAddAttachmentDialog" >上传附件</b-dropdown-item>
              <b-dropdown-item @click="showSelectAttachmentDialog">选择已上传附件</b-dropdown-item>
            </b-dropdown>
          </b-nav-item>
        </template>

    </b-tabs>
    </div>

    <!-- 添加附件对话框 -->
    <b-modal
      id="addAttachmentModal"
      title="添加发票附件"
      incline
      v-model="addAttachmentDialogVisible"
      @ok="handleAddAttachment"
    >
      <template slot="modal-ok">确定</template>
      <template slot="modal-cancel">取消</template>
      <div id="alert"></div>
      <form enctype="multipart/form-data">

            <b-form-group label="附件" label-cols="2">
              <b-form-file
                v-model="file1"
                :state="Boolean(file1)"
                accept=".pdf"
                placeholder="请选择一个PDF文件或者拖到这里..."
                drop-placeholder="将文件拖放到这里..."
              ></b-form-file>
            </b-form-group>

            <b-form-group label="身份认证" label-cols="2" v-show="!isUserLogined">
              <b-form-input 
                v-model="addAttachmentDto.accountNo" 
                placeholder="请输入上传发票所使用的邮箱进行验证">
              </b-form-input>
            </b-form-group>

      </form>
    </b-modal>

    <!-- 删除附件对话框 -->
    <b-modal
      id="removeAttachmentModal"
      title="删除发票附件"
      incline
      v-model="removeAttachmentDialogVisible"
      @ok="handleRemoveAttachment"
    >
      <template slot="modal-ok">确定</template>
      <template slot="modal-cancel">取消</template>
      <div id="alert"></div>
      <p>您确实要删除 "{{this.currentAttachmentFileName}}" 吗？</p>
      <form enctype="multipart/form-data">

            <b-form-group label="身份认证" label-cols="2" v-show="!isUserLogined">
              <b-form-input 
                v-model="addAttachmentDto.accountNo" 
                placeholder="请输入上传发票所使用的邮箱进行验证">
              </b-form-input>
            </b-form-group>

      </form>
    </b-modal>

    <!-- 选择附件对话框start -->
    <b-modal
      id="selectAttachmentModal"
      title="选择发票附件"
      incline
      v-model="selectAttachmentDialogVisible"
      @ok="handleSelectAttachment"
      size="lg"
    >
      <template slot="modal-ok">确定</template>
      <template slot="modal-cancel">取消</template>
      <div id="alert"></div>

      <!-- 列表 -->
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="notMatchAttachments"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

      </b-table>

    </b-modal>
    <!-- 选择附件对话框end -->


  </div>
</template>

<script>
import * as invCheckFacade from "../../../api/invcheck-facade.js";
import * as attachmentFacade from "../../../api/attachment-facade.js";

export default {
  props:{
    file: String,
    file1: File
  },
  // validations:
  data() {
    return {
        id:"",
        tableMaxHeight: 500,
        tabs: [],
        tabCounter: 0,
        tableLoading:false,
        files:{},
        addAttachmentDialogVisible: false,
        selectAttachmentDialogVisible: false,
        addAttachmentDto: {},
        showAlert: false,
        msg: "",
        isUserLogined: false,
        removeAttachmentDialogVisible: false,
        currentAttachmentId:"",
        currentAttachmentFileName: "",
        notMatchAttachments:{},
        orgId:"",
        selectedAttachmentId:"",

        fields: [
          {
            key: "title",
            label: "类型"
          },
          {
            key: "fileSubmitter",
            label: "提交人"
          },
          {
            key: "submitTime",
            label: "提交时间"
          },
          {
            key: "totalAmount",
            label: "金额"
          },
        ],        
    };
  },
  created() {
    // this.id = this.$route.query.id;
    this.init()
  },
  mounted() {
    window.onresize = () => {
      this.changeIFrameMaxHeight()
    }
    this.changeIFrameMaxHeight()
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    init(){
      var id = this.$route.query.id
      invCheckFacade
        .getFiles(id) // 异步调用后台接口
        .then(res => {
          this.files = res.invoiceCheckViewDtos; // 
          this.isUserLogined = res.logined;
          this.orgId = res.orgId;
        })
        .catch(err => {
          console.log("err", err);
        });

    },
    // 自动更改iframe高度
    changeIFrameMaxHeight () {
      let height = document.body.offsetHeight // 网页可视区域高度
      this.tableMaxHeight = height - 60
      // console.log(this.tableMaxHeight)
    },

    // 获取iframe的显示地址
    getViewerUrl(file){
      var downloadUrl = process.env.VUE_APP_PREFIX + file.downloadUrl
      let viewerUrl;
      if(file.fileFormat == "OFD"){
        viewerUrl = "./ofd/index.html?file=";
      }else if(file.fileFormat == "PDF"){
        viewerUrl = "./pdf/web/viewer.html?file=";
      }else{
        viewerUrl = "./#/imageViewer?file=";
      }

      return viewerUrl + encodeURIComponent(downloadUrl)
    },

    // 添加附件
    showAddAttachmentDialog(){
      this.addAttachmentDialogVisible = true;
    },

    // 处理上传
    handleAddAttachment(e){
      e.preventDefault();
      // 判断文件是否为空
      if(!this.file1){
        this.$message({
          message: "附件不允许为空",
          type: "danger"
        });

        return;
      }

      // 判断邮箱是否为空，格式是否正确
      if(!this.isUserLogined ){
        if (this.addAttachmentDto.accountNo==null ||this.addAttachmentDto.accountNo.trim()==""){
          this.$message({
            message: "邮箱不允许为空",
            type: "danger"
          });
          return;
        }
        if(!this.addAttachmentDto.accountNo.includes("@")){
          this.$message({
            message: "邮箱格式不正确",
            type: "danger"
          });
          return;

        }
      }

      var data = new FormData();
      data.append("file",this.file1);
      data.append("accountNo",this.addAttachmentDto.accountNo);
      data.append("fileProcessId", this.$route.query.id)

      attachmentFacade
        .addAttachment(data) // 异步调用后台接口
        .then(() => {
          this.$message({
            message: "添加附件成功",
            type: "success"
          });
          this.init();
          this.addAttachmentDialogVisible=false;

        })
        .catch(err => {
          console.log(err)
        });
    },

    // 删除附件对话框
    remove(id, name){
      console.log(id);
      this.currentAttachmentId = id;
      this.currentAttachmentFileName = name;
      this.removeAttachmentDialogVisible = true;
    },

    // 执行删除附件
    handleRemoveAttachment(e){
      e.preventDefault();
      // 删除
      var data = new FormData();
      data.append("accountNo",this.addAttachmentDto.accountNo);
      data.append("attachmentId", this.currentAttachmentId)

      attachmentFacade
        .removeAttachment(data) // 异步调用后台接口
        .then(() => {
          this.$message({
            message: "移除附件成功",
            type: "success"
          });
          this.init();
          this.removeAttachmentDialogVisible=false;
        })
        .catch(err => {
          console.log(err)
        });
    },

    // 选择附件
    showSelectAttachmentDialog(){
      this.selectAttachmentDialogVisible = true;
      attachmentFacade
        .findNotMatchAttachment(this.orgId) // 异步调用后台接口
        .then(res => {
          this.notMatchAttachments = res;
        })
        .catch(err => {
          console.log(err)
        });
    },

    // 选择并且处理
    handleSelectAttachment(){
      attachmentFacade
        .associate(this.$route.query.id, this.selectedAttachmentId) // 异步调用后台接口
        .then(() => {
          this.init();
          this.selectAttachmentDialogVisible=false;
        })
        .catch(err => {
          console.log(err)
        });

    },

    //选择某一条预算单
    onRowSelected(items) {
      if (items && items.length > 0) {
        this.selectedAttachmentId = items[0].id;
      } else {
        this.selectedAttachmentId = "";
      }
    },

  }
};
</script>

<style scopde>
  .nav-link {
    color: #000000 !important;
  }
    .nav-link:hover{
    background-color: #ffffff ;
  }  
</style>
